import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { EMAIL_SETTINGS_API } from '../utils/api';
import Navbar from '../components/Navbar';

export default function EmailSettings() {
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [active, setActive] = useState(false);
  const [form, setForm] = useState({
    provider: '',
    senderEmail: '',
    smtpKey: ''
  });

  const token = localStorage.getItem('token');
  const customer_id = JSON.parse(atob(token)).customer_id;

  useEffect(() => {
    fetchEmailSettings();
  }, []);

  const fetchEmailSettings = async () => {
    try {
      const res = await axios.post(EMAIL_SETTINGS_API, {
        customer_id,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success && res.data.data) {
        const { active_status, provider, sender_email, smtp_key } = res.data.data;

        const hasData = provider || sender_email || smtp_key;
        if (!hasData) {
          setNoData(true);
        }

        setForm({
          provider,
          senderEmail: sender_email,
          smtpKey: smtp_key
        });
        setActive(active_status === '1' || active_status === 1);
      } else {
        setNoData(true);
      }
    } catch (err) {
      console.error('Error loading Email settings:', err);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  const isComplete = (value) => value?.trim() !== '';

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <div>Loading Email Configuration...</div>
      </div>
    );
  }

  if (noData) {
    return (
      <div className="container mt-4">
        <h3 className="mb-4">✉️ Email Configuration</h3>
        <Alert variant="warning">
          ⚠️ No Email configuration found for this customer. For Activation Please contact to your service provider.
        </Alert>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h3 className="mb-4">✉️ Email Configuration</h3>

        <Card className="shadow p-4">
          <Form>
            <Form.Check
              type="switch"
              id="email-switch"
              label={active ? '✅ Email Active' : '❌ Email Inactive'}
              checked={active}
              disabled
              readOnly
              className="mb-4"
            />

            <Row className="mb-3 align-items-center">
              <Col md={4}><Form.Label>📨 Email Provider</Form.Label></Col>
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="provider"
                  value={form.provider}
                  readOnly
                  plaintext
                />
              </Col>
              <Col md={2} className="text-center">
                {isComplete(form.provider) ? '✅' : '❌'}
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={4}><Form.Label>📧 Sender Email</Form.Label></Col>
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="senderEmail"
                  value={form.senderEmail}
                  readOnly
                  plaintext
                />
              </Col>
              <Col md={2} className="text-center">
                {isComplete(form.senderEmail) ? '✅' : '❌'}
              </Col>
            </Row>

            <Row className="mb-4 align-items-center">
              <Col md={4}><Form.Label>🔐 SMTP API Key</Form.Label></Col>
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="smtpKey"
                  value={form.smtpKey}
                  readOnly
                  plaintext
                />
              </Col>
              <Col md={2} className="text-center">
                {isComplete(form.smtpKey) ? '✅' : '❌'}
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </>
  );
}
